import styles from './StageStopModal.module.css';

import { address_server_short, PUBLIC_ASSETS } from 'config';
import Icon from 'ui/Icon';
import { useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';
import SelectPathStorage from 'widgets/SelectPathStorage';

const StopObjectPath = ({ object, index }) => {
  const { setValue } = useFormContext();
  const [node, setNode] = useState(null);
  const [line, setLine] = useState(null);
  const [column, setColumn] = useState(null);

  useEffect(() => {
    setValue(`params.storaging.[${index}].id_object`, object.id);
    setValue(`params.storaging.[${index}].derived`, object.derived);
  }, []);

  useEffect(() => {
    if (node) {
      setValue(`params.storaging.[${index}].id_storage`, node.id);
      setValue(`params.storaging.[${index}].storage_entity`, node.entity);
      setLine(null);
      setColumn(null);
    }
  }, [node]);

  useEffect(() => {
    if (line) {
      setValue(`params.storaging.[${index}].line`, line);
    }
  }, [line]);

  useEffect(() => {
    if (column) {
      setValue(`params.storaging.[${index}].column`, column);
    }
  }, [column]);

  return (
    <div key={object.id} className={styles.objectsContainer}>
      <div className={styles.wrapperIcon}>
        <Icon width={44} height={44} src={address_server_short + PUBLIC_ASSETS + object.image} />
        <div>{object.name}</div>
      </div>
      <div>Расположение:</div>
      <div>
        <SelectPathStorage
          node={node}
          setNode={setNode}
          line={line}
          setLine={setLine}
          column={column}
          setColumn={setColumn}
        />
      </div>
    </div>
  );
};

export default StopObjectPath;
